import { FC } from 'react';

import { EmployeeInfo } from 'src/components/EmployeeInfo/EmployeeInfo';
import { Section } from 'src/components/Section/Section';

export interface ReservedByEmployeeProps {
  responsible: string;
}

export const ReservedByEmployeeInfo: FC<ReservedByEmployeeProps> = ({
  responsible,
}) => {
  return (
    <Section title='Закреплено за' testId='responsibleSection'>
      <EmployeeInfo employeeNumber={responsible} testId='responsible' />
    </Section>
  );
};
